module.exports = __webpack_public_path__ + "img/coupon_tutorial_bepiu03.ec290e21.png";